//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'Searchbar',
  props: { hidden: { type: Boolean, default: false } },
  data() {
    return {
      searchPayload: {
        keywords: null,
        lecturerTeachingFieldIds: null,
      },
    };
  },
  computed: {
    ...mapGetters('lecturer', ['teachingFields']),
  },
  methods: {
    onChangeItem() {
      this.$emit('search', this.searchPayload);
    },
  },
};
